module.exports = __webpack_public_path__ + "static/media/question_mark.b314bec3.jpg";